import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState } from 'editor/src/store/variants/types';

const setSelectedGroupReducer = (state: VariantsState, action: PayloadAction<string>) => {
  state.selectedGroupKey = action.payload;
};

export default setSelectedGroupReducer;
